import type { IHttpSessionAuthProvider } from "@web3auth/auth";

export type refreshTokenProviderFn = (forceRefresh?: boolean) => Promise<string>;

export class TokenProviderAdapter implements IHttpSessionAuthProvider {
  constructor(private provider: refreshTokenProviderFn) {}

  async getAccessToken(): Promise<string | null> {
    return this.provider(false);
  }

  async handleUnauthorized(): Promise<string> {
    return this.provider(true);
  }
}
